<template>
  <b-overlay id="overlay-background" class="system-log-page" :show="loading" rounded="sm">
    <div class="page-title">
      <PageTitle :main="$t('historico-alteracoes')" sub="" imagem="Monitoramento.png" />

      <div class="export-options">
        <label>
          <input type="radio" name="exportFormat" value="pdf" class="hidden-radio" v-model="selectedExportFormat" />
          <span class="custom-radio pdf" :class="{ 'selected': selectedExportFormat === 'pdf' }">PDF</span>
        </label>

        <label>
          <input type="radio" name="exportFormat" value="csv" class="hidden-radio" v-model="selectedExportFormat" />
          <span class="custom-radio csv" :class="{ 'selected': selectedExportFormat === 'csv' }">CSV</span>
        </label>

        <img @click="exportTable" class="dropItem" src="@/assets/exportar.png" alt="Exportar cenário" />
      </div>
    </div>

    <div class="system-log-grid">
      <vue-table-dynamic class="table-log" :params="params" @row-click="onRowClick"
        @selection-change="onSelectionChange" @select="handleCheckLog" ref="table">
        <template v-slot:column-0="{ props }">
          <span class="cell--slot-0"> {{ props.row }} </span>
        </template>

        <template v-slot:column-2="row">
          {{ row.props.cellData }}
          <div class="module">
            <span :class="row.props.rowData[0].data.split('-')[1] == 'true'
              ? 'warning-date'
              : ''
              ">
              <b-icon v-if="row.props.rowData[0].data.split('-')[1] == 'true'" class="question-icon alert-icon"
                font-scale="1.2" icon="exclamation-triangle-fill" v-b-popover.hover="{
                  variant: 'warning',
                  content: row.props.rowData[0].data.split('-')[2],
                }"></b-icon>
            </span>
          </div>
        </template>
      </vue-table-dynamic>

      <div class="system-log-footer">
        <div class="footer-content">
          <p class="logs-count">{{ $t("logs") }} {{ this.items.length }}</p>
          <div class="refresh-button">
            <img id="refresh-logs" src="@/assets/atualizar.png" :alt="$t('atualizar')" :title="$t('atualizar')"
              @click="getLogsAudit" />
          </div>
        </div>
      </div>
    </div>

    <b-modal id="viewlogdetail" size="xl" hide-footer>
      <div slot="modal-title" class="img-slot">
        <img style="width: 33px; height: 33px; margin-right: 10px" src="@/assets/aceitarplanejamento.png"
          alt="salvar_analise" />
        {{ $t("detalhes-log") }}
      </div>
      <LogDetailsModal :log="logSelected" :onClose="closeModal"></LogDetailsModal>
    </b-modal>
  </b-overlay>
</template>


<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import { urlMainAPI, defaultSuccess } from "@/global";
import PageTitle from "../../template/PageTitle";
import axios from "axios";
import LogDetailsModal from "./ViewLogDetail.vue";
import { FiltersMixin } from "../../mixins/filtersMixin";
import { UtilsMixin } from "../../mixins/utilsMixin";

export default {
  name: "ChangeHistoryLogs",
  components: { PageTitle, LogDetailsModal },

  mixins: [FiltersMixin, UtilsMixin],

  data() {
    return {
      items: [],
      itemsBackup: [],
      selected: [],
      loading: true,
      logSelected: {},
      logInitiExpired: new Date(),
      clickedOnTable: false,
      selectedExportFormat: "pdf",
      checkedLogs: [],
      params: {
        data: [
          [
            this.$t("linha"),
            this.$t("userName"),
            this.$t("modulo"),
            this.$t("date"),
            this.$t("productionUnit"),
          ],
        ],
        showCheck: true,
        header: "row",
        textOverflow: "ellipsis",
        border: true,
        stripe: true,
        enableSearch: true,
        pagination: true,
        pageSize: 10,
        pageSizes: [10, 20, 50],
        filter: [],
        columnWidth: [
          { column: 0, width: 100 },
          { column: 1, width: 300 },
          { column: 2, width: 700 },
          { column: 3, width: 200 },
          { column: 4, width: 300 },
        ],
      },
      LogDeletionWarningThreshold: 0,
      message: "",
    };
  },

  methods: {
    async onRowClick(indice) {
      if (this.clickedOnTable && indice != 0) {
        let log = this.items[indice - 1];
        if (log) {
          this.logSelected = { ...log };

          this.$bvModal.show("viewlogdetail");
        }
      } else {
        this.clickedOnTable = true;
        this.dbClickTimer();
      }
    },

    dbClickTimer() {
      setTimeout(() => {
        this.clickedOnTable = false;
      }, 400);
    },

    onSelectionChange(checkedRowsData) {
      checkedRowsData.shift();

      let checkOcc = [];
      let checkOccIds = [];

      this.$refs.table.tableData.activatedRows.forEach((item) => {
        if (item.checked && item.checked == true) {
          let found = checkedRowsData.find(
            (occ) => occ[0] == item.cells[0].data
          );
          if (found) {
            checkOcc.push(found);
            checkOccIds.push(item.index);
          }
        }
      });

      this.$refs.table.tableData.rows.forEach((item) => {
        if (!checkOccIds.includes(item.index)) item.checked = false;
      });

      if (checkedRowsData && checkedRowsData.length > 0) {
        this.$refs.table.tableData.rows[0].checked = true;
      }

      let formatedOcc = this.formatSelectedLogs(checkOcc);
      this.checkedlogs = formatedOcc;
    },

    handleCheckLog(checked, _, data) {
      let logObj = this.items.find((item) => item.id == data[0].split("-")[0]);

      if (this.checkedlogs) {
        if (checked == true) {
          this.checkedlogs.push(logObj);
        } else {
          this.checkedlogs.splice(this.checkedlogs.indexOf(logObj), 1);
        }
      }
    },

    buildLogGrid() {
      this.params.data.splice(1);
      this.params.filter = [];
      this.items.forEach((o) => {
        this.SetFilter(o);
        this.params.data.push(this.getRow(o));
      });

      this.params.filter.forEach(async (f) => {
        if (!(f.column == 4)) f.content = await this.Sort(f.content, "value");
        else f.content = await this.SortDate(f.content, "value");
      });
    },

    async SetFilter(log) {
      for (let i = 1; i < 5; i++) {
        let filterFounded = this.params.filter.find((f) => f.column == i);
        if (filterFounded) {
          let obj = this.getObjectColumn(log, i);
          let contentFinded = filterFounded.content.find(
            (c) => c != undefined && c.value == obj.value
          );
          if (!contentFinded) filterFounded.content.push(obj);
        } else {
          this.params.filter.push({
            column: i,
            content: [this.getObjectColumn(log, i)],
            method: (value, tableCell) => {
              return tableCell.data == value;
            },
          });
        }
      }
    },

    getObjectColumn(log, i) {
      if (i == 1)
        return {
          text: log.userName,
          value: log.userName,
        };

      if (i == 2)
        return {
          text: log.modulo,
          value: log.modulo,
        };

      if (i == 3) {
        return {
          text: this.MaskDate(log.date),
          value: this.MaskDate(log.date),
        };
      }

      if (i == 4) {
        return {
          text: log.productionUnit,
          value: log.productionUnit,
        };
      }
    },

    getRow(o) {
      return [
        o.id +
        "-" +
        o.isNearDeletion +
        "-" +
        `${this.$t(
          "os-logs-de-alteracoes-serao-apagados-automaticamente-em"
        )}${o.daysToDeletion} ${this.$t("dias")}`,
        o.userName,
        o.modulo,
        this.MaskDateTimeShort(o.date),
        o.productionUnit,
      ];
    },

    formatSelectedLogs(logList) {
      let formatedList = [];

      for (let occ of logList) {
        let logFound = this.items.find((log) => log.id == occ[0].split("-")[0]);

        if (logFound != undefined) {
          let { ...occurence } = logFound;
          let formatedFound = {
            ...occurence,
          };
          formatedList.push(formatedFound);
        }
      }
      return formatedList;
    },

    applyTableFilters(filters) {
      if (filters.activatedFilter != null)
        this.$refs.table.activatedFilter = filters.activatedFilter;
      if (filters.activatedSort != null)
        this.$refs.table.activatedSort = filters.activatedSort;
      if (filters.pagesize != null)
        this.$refs.table.pageSize = filters.pagesize;

      if (filters.rowsStatus.length > 0) {
        this.$refs.table.tableData.rows.forEach((item) => {
          let find = filters.rowsStatus.find(
            (item2) => item2.idx == item.cells[0].data
          );

          if (find) item.filtered = find.isFiltered;
        });
      }

      if (filters.filterConfig.length > 0) {
        for (let filter of filters.filterConfig) {
          this.$refs.table.filterConfig[filter.idx].content[
            filter.contentIdx
          ].checked = true;
        }
      }

      this.$refs.table.updatePagination();
      this.$refs.table.toPage(1);
    },

    async getLogsAudit() {
      this.loading = true;
      try {
        await axios.get(`${urlMainAPI}/getlogsaudit`).then((res) => {
          if (res.status === 200) {
            this.LogRetentionDays = res.data.LogRetentionDays;
            this.LogDeletionWarningThreshold =
              res.data.LogDeletionWarningThreshold;

            this.itemsBackup = res.data.Data.map((a) => {
              const data = a.date ? new Date(a.date) : new Date();

              const logInitiExpired = new Date(data);
              logInitiExpired.setDate(
                logInitiExpired.getDate() + res.data.LogRetentionDays
              );
              const currentDate = new Date();
              const daysToDeletion = Math.ceil(
                (logInitiExpired - currentDate) / (1000 * 60 * 60 * 24)
              );
              const isNearDeletion =
                daysToDeletion <= res.data.LogDeletionWarningThreshold;
              return {
                ...a,
                data,
                logInitiExpired,
                isNearDeletion,
                daysToDeletion,
              };
            });
            this.items = this.itemsBackup;
            this.buildLogGrid();
            defaultSuccess(this.$t("tabela-atualizada"));
          }
        });
      } catch (error) {
        console.error(error);
        throw error;
      }
      if (this.$refs.table && this.savedFilters != null) {
        this.applyTableFilters(this.savedFilters);
      }
      this.loading = false;
    },

    closeModal() {
      this.$bvModal.hide("viewlogdetail");
    },

    exportTable() {
      if (this.checkedlogs && this.checkedlogs.length > 0) {
        if (this.selectedExportFormat === "pdf") {
          const doc = new jsPDF();
          doc.setFont("helvetica", "normal");
          doc.text(this.$t("historico-alteracoes"), 14, 15);

          let currentY = 30;
          const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();

          this.checkedlogs.forEach((item, index) => {
            const title = `${index + 1}. ${item.userName} - ${item.modulo} - ${this.MaskDate(item.date)} - ${item.productionUnit}`;
            const message = (item.message || "").replace(/→/g, "->");
            const splitMessage = doc.splitTextToSize(`${this.$t("mensagem")}: ${message}`, 180);

            // Renderiza título
            doc.setFontSize(12);
            doc.text(title, 14, currentY);
            currentY += 8;

            doc.setFontSize(10);
            const lineHeight = 5;

            for (let i = 0; i < splitMessage.length; i++) {
              if (currentY + lineHeight > pageHeight - 10) {
                doc.addPage();
                currentY = 20;
              }
              doc.text(splitMessage[i], 14, currentY);
              currentY += lineHeight;
            }

            currentY += 5; // espaço extra entre registros
          });

          doc.autoPrint();
          doc.save("historico_alteracoes.pdf");
        } else if (this.selectedExportFormat === "csv") {

          // Definir cabeçalhos das colunas
          const headers = [
            "Índice",
            "Usuário",
            "Módulo",
            "Data",
            "Unidade",
            "Tipo de Operação",
            "Detalhes da Alteração"
          ];

          // Iniciar com o cabeçalho
          let csvContent = headers.join(";") + "\r\n";

          // Converter cada registro em uma linha CSV
          this.checkedlogs.forEach((item, index) => {
            // Extrair informações do message
            let operationType = "";
            let changeDetails = "";

            if (item.message) {
              // Extrair "Tipo de Operação" do message
              const typeMatch = item.message.match(/Tipo de Operação: ([^\r\n]+)/);
              if (typeMatch && typeMatch[1]) {
                operationType = typeMatch[1].trim();
              }

              // Extrair detalhes da alteração (tudo após "Tipo de Operação")
              const messageLines = item.message.split("\n");
              const typeIndex = messageLines.findIndex(line => line.includes("Tipo de Operação"));

              if (typeIndex !== -1 && typeIndex < messageLines.length - 1) {
                // Pegar todas as linhas após "Tipo de Operação"
                changeDetails = messageLines.slice(typeIndex + 1).join(" | ").trim();
              }
            }

            // Formatação especial para a data
            let formattedDate = "";
            if (item.date) {
              // Assumindo que this.MaskDate pode não estar funcionando corretamente
              // Vamos implementar uma formatação direta
              try {
                // Se item.date for uma string de data ISO ou um objeto Date
                const dateObj = new Date(item.date);
                if (!isNaN(dateObj.getTime())) {
                  // Formatação dd/mm/aaaa
                  const day = String(dateObj.getDate()).padStart(2, '0');
                  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                  const year = dateObj.getFullYear();
                  formattedDate = `${day}/${month}/${year}`;
                } else {
                  // Se não for uma data válida, usar o valor original
                  formattedDate = item.date;
                }
              } catch (e) {
                // Em caso de erro, usar o valor original
                formattedDate = item.date;
              }
            }

            // Criar linha CSV
            const row = [
              index + 1,
              item.userName,
              item.modulo,
              formattedDate, // Usando a data formatada
              item.productionUnit,
              operationType,
              changeDetails
            ];

            // Escapar aspas duplas e campos especiais
            const escapedRow = row.map(field => {
              if (field === null || field === undefined) return "";
              // Garantir que o campo seja uma string e escapar aspas duplas
              return `"${String(field).replace(/"/g, '""')}"`;
            });

            csvContent += escapedRow.join(";") + "\r\n";
          });

          // Convertendo para UTF-8 com BOM
          const bomPrefix = new Uint8Array([0xEF, 0xBB, 0xBF]);
          const textEncoder = new TextEncoder();
          const csvContentEncoded = textEncoder.encode(csvContent);

          // Concatenando o BOM com o conteúdo codificado
          const csvWithBom = new Uint8Array(bomPrefix.length + csvContentEncoded.length);
          csvWithBom.set(bomPrefix);
          csvWithBom.set(csvContentEncoded, bomPrefix.length);

          // Cria o Blob com UTF-8
          const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8" });

          // Faz o download
          if (navigator.msSaveBlob) {
            // Para IE 10+
            navigator.msSaveBlob(blob, "historico_alteracoes.csv");
          } else {
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "historico_alteracoes.csv");
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          }
        }
      }
    }
    ,
  },

  mounted() {
    this.getLogsAudit();
  },
};
</script>

<style scoped>
.system-log-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.export-options {
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-radio {
  display: inline-block;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  transition: all 0.2s ease;
}

.custom-radio.pdf {
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.custom-radio.csv {
  background-color: #d1e7dd;
  border-color: #badbcc;
}

.custom-radio.pdf.selected {
  background-color: #dc3545;
  color: white;
  border-color: #dc3545;
  font-weight: bold;
  box-shadow: 0 0 5px rgba(220, 53, 69, 0.5);
}

.custom-radio.csv.selected {
  background-color: #198754;
  color: white;
  border-color: #198754;
  font-weight: bold;
  box-shadow: 0 0 5px rgba(25, 135, 84, 0.5);
}

.hidden-radio {
  display: none;
}

.dropItem {
  cursor: pointer;
  height: 38px;
}

.system-log-grid {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.table-log {
  flex: 1;
  overflow: auto;
}

.system-log-footer {
  margin-top: 10px;
  border-top: 1px solid #dee2e6;
  padding-top: 10px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 10px;
}

.logs-count {
  margin: 0;
  font-weight: 500;
}

.refresh-button {
  display: flex;
  justify-content: flex-end;
}

.refresh-button img {
  height: 38px;
  cursor: pointer;
  transition: transform 0.2s;
}

.refresh-button img:hover {
  transform: rotate(30deg);
}

.warning-date {
  color: #ffc107;
}

.alert-icon {
  margin-left: 5px;
}

/* Responsive adjustments for notebook screens */
@media (max-width: 1366px) {
  .footer-content {
    padding: 0 5px;
  }

  .refresh-button img {
    height: 32px;
  }
}

@media (max-width: 1024px) {
  .system-log-footer {
    padding-top: 5px;
    margin-top: 5px;
  }

  .footer-content {
    gap: 10px;
  }
}
</style>
